import { useMemo } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import { Button } from '~/components/ui/button';
import { PHONE_TYPES } from '~/constants/vCard';
import { getIsDesktop } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

import {
  StyledContentContainer,
  StyledDeleteButtonContainer,
  StyledPhoneItemContainer,
  StyledPhoneItemTopContainer,
} from './styled';

export const ContactInfoContent = () => {
  const { t } = useTranslation();
  const { control, trigger } = useFormContext();

  const isDesktop = useSelector(getIsDesktop);

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'phones',
  });

  const onAddPhone = () => {
    append({ phone: '', type: 'HOME' });
    trigger(`phones.${fields.length}.phone`);
  };

  const triggerPhone = (event, index) => {
    if (event.target.value.length <= 1) {
      trigger(`phones.${index}.phone`);
    }
  };

  const phoneOptions = useMemo(
    () =>
      PHONE_TYPES.map(({ id, translate, Icon }) => ({
        value: id,
        label: t(translate),
        appendLeft: <Icon sx={{ color: COLORS.black06, marginRight: 2 }} />,
      })),
    [t],
  );

  return (
    <StyledContentContainer>
      {!!fields.length && (
        <StyledContentContainer>
          {fields.map(({ id }, index) => (
            <StyledPhoneItemContainer key={id}>
              {isDesktop ? (
                <FormTextField
                  name={`phones.${index}.type`}
                  fullWidth
                  select
                  options={phoneOptions}
                  absoluteHelperText
                />
              ) : (
                <StyledPhoneItemTopContainer>
                  <FormTextField
                    name={`phones.${index}.type`}
                    fullWidth
                    select
                    options={phoneOptions}
                    absoluteHelperText
                  />
                  <StyledDeleteButtonContainer>
                    <IconButton onClick={() => remove(index)} sx={{ width: '40px', height: '40px' }}>
                      <ClearIcon />
                    </IconButton>
                  </StyledDeleteButtonContainer>
                </StyledPhoneItemTopContainer>
              )}

              <FormTextField
                name={`phones.${index}.phone`}
                label={t('other:phone')}
                inputProps={{ maxLength: 40 }}
                fullWidth
                onChange={(e) => triggerPhone(e, index)}
                absoluteHelperText
              />
              {isDesktop && (
                <StyledDeleteButtonContainer>
                  <IconButton onClick={() => remove(index)} sx={{ width: '40px', height: '40px' }}>
                    <ClearIcon />
                  </IconButton>
                </StyledDeleteButtonContainer>
              )}
            </StyledPhoneItemContainer>
          ))}
        </StyledContentContainer>
      )}
      <Button
        type="primary-outlined"
        size="xs"
        startIcon={<AddIcon />}
        onClick={onAddPhone}
        sx={{ marginTop: fields.length ? '12px' : undefined, width: 'fit-content' }}
      >
        {t('template5:addPhone')}
      </Button>
      <FormTextField name="email" label={t('other:email')} inputProps={{ maxLength: 254 }} fullWidth />
      <FormTextField name="website" label={t('other:website')} inputProps={{ maxLength: 500 }} fullWidth />
    </StyledContentContainer>
  );
};
